import React from 'react';

import Modal from 'components/shared/Modal/Modal';
import Button from 'components/shared/Button/Button';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

import ConsentForm from './ConsentForm';

const ConsentModal = ({
  showTechnologyModal,
  hideTechnologyModal,
  updateSurcharge,
  setPractice,
  practice
}) => {
  return (
    <Modal
      isOpen={showTechnologyModal}
      handleClose={hideTechnologyModal}
      title="Technology consent"
      bodyClassName="overflow-hidden"
      prevButton={
        <Button
          close
          onClick={hideTechnologyModal}
          variant="link"
          icon="arrow-left-linear"></Button>
      }>
      <ConsentForm
        hideTechnologyModal={hideTechnologyModal}
        setPractice={setPractice}
        practice={practice}
        updateSurcharge={updateSurcharge}
      />
    </Modal>
  );
};

export default withErrorBoundary(ConsentModal);
